export type SearchMessageType = 'THREAD' | 'CONVERSATION' | 'CALL';

export const SearchMessageType = {
  THREAD: 'THREAD' as SearchMessageType,
  CONVERSATION: 'CONVERSATION' as SearchMessageType,
  CALL: 'CALL' as SearchMessageType,
};
